import React from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { fileUrl } from "../../Tools/APIs";
import "./styles.css";

// import required modules
import { Pagination } from "swiper";
import "swiper/css";
import "swiper/css/pagination";

import MembersCard from "../Cards/MembersCard";
import LoadingMembersCard from "../Cards/LoadingMembersCard";

function SectionSwiperHome({ data, title, isLoading }) {
  return (
    <>
      <div className="!bg-gray-100 rounded-2xl shadow-xl shadow-gray-200">
        <Swiper
          slidesPerView={3}
          pagination={{
            clickable: true,
          }}
          modules={[Pagination]}
          className="mySwiper  custom-swiper"
          breakpoints={{
            1020: {
              slidesPerView: 3,
            },
            767: {
              slidesPerView: 2,
            },
            0: {
              slidesPerView: 1,
            },
          }}>
          {(!data?.data ? [1, 2, 3, 4] : data)?.map((e, i) => (
            <SwiperSlide key={i} className="!my-10 ">
              {!isLoading ? (
                <MembersCard
                  isOnline={e?.is_online}
                  id={e?.login_details?.id}
                  image={e.images.length > 0
                    ? fileUrl + e.images[e.images.length - 1].image
                    : ""}
                  check={e.is_caring?.cared_id}
                  name={e?.login_details?.username}
                  age={e.social_status?.age}
                  city={e.nationality_residence?.city?.name}
                  job={e.study_work?.job?.name}
                  status={
                    title === "content.HealthConditions"
                      ? e.study_work?.health_status?.name
                      : e.social_status?.social_status?.name
                  }
                  user={e}
                />
              ) : (
                <LoadingMembersCard />
              )}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </>
  );
}

export default SectionSwiperHome;
